import {SoftDeleteEntity} from './soft-delete-entity';
import {Customer} from './customer';
import {Product} from './product';
import {Country} from './country';
import {OrderImport} from './order-import';
import {Card} from './card';
import {OrderStatus} from './order-status';
import {OrderCancellationReason} from './order-cancellation-reason';
import {EmailReminder} from './email-reminder';
import {WebIdTransaction} from './web-id-transaction';
import {Invoice} from './invoice';

import {OrderCancellationStatus} from './order-cancellation-status';
import {PepStatus} from './pep-status';
import {IdentStatus, ReferralStatus} from './ident-status';
import {CardReorderReason} from './card-reorder-reason';
import {CardView} from './cardView';
import {BaseEntity} from './base-entity';

export class Order extends SoftDeleteEntity {
  public externalRef: string;
  public externalKey: string;

  public cardName: string;
  public invoiceNumber: string;
  public cancellationInvoiceNumber: string;

  public orderLanguage: number;

  public protectedOrderId: string;

  public invoiceId: number;
  public invoice: Invoice;

  public cancellationInvoiceId: number;
  public cancellationInvoice: Invoice;

  public sex: string;
  public title: string;
  public firstName: string;
  public lastName: string;
  public customerCompanyName: string;
  public address: string;
  public zipCode: string;
  public city: string;
  public countryIsoCode: number;
  public country: Country;
  public phone: number;
  public dob: Date;
  public productId: number;
  public product: Product;
  public email: string;
  public nationality: string;
  public nationalityIsoCode: number|null;
  public ipAddress: string;
  public orderDate: Date; // from file
  public shippedDate: Date|null;
  public awaitingShipmentDate: Date|null;

  public voucherCode: string;
  public smsConfirmationCode: number;
  public subscribeToNews: boolean;
  public isImported: boolean;

  public paymentEmailReminders: EmailReminder[];

  public paymentType: string;
  public paymentType2: string;

  public card: Card;

  public customerId: number;
  public customer: Customer;

  public status: OrderStatus;
  public cancellationReason: OrderCancellationReason;
  public cancellationComment: string;
  public cancellationStatus: OrderCancellationStatus;

  public userCancellationReason: number;
  public userCancellationReasonName: string;

  public cancellationDate: Date; // from file

  public importId: number;
  public import: OrderImport;

  public statusName: string;
  public cancellationReasonName: string;
  public productName: string;
  public productInternalName: string;
  public productShortName: string;
  public countryName: string;
  public companyName: string;

  public webIdTransaction: WebIdTransaction|null;

  public language: string;

  public partnerCustomerId: string;

  public wantTotalCardInfos: boolean;

  public creationDate: Date;

  public isReorderOrder: boolean;
  public reorderedCardId: number;
  public reorderedCard: Card;
  public reorderReason: CardReorderReason;


  public webIdTransactionStatus: number;

  public appDeviceId: number|null;
  public appDevice: AppDevice|null;

  public source: string|null;

  public refersionCartId: string;
  public partRef: string;

  public loadAmount: number|null;
  public referral: Referral | null;


  public primaryCardId: number|null;
  public primaryCard: Card|null;
  public isVirtualOnly: boolean;


}

export class ClientOrder extends Order {
  public addressOnly: string;
  public building: string;
}


export class OrderWithIdent extends Order {
  public customerPepStatus: PepStatus|null;
  public customerIdentStatus: IdentStatus|null;
  public productIsNoIdentCreationActive: boolean|null;
}

export class AppDevice {
  public deviceId: string;
  public os: number;

  public deviceToken: string;
  public creationDate: Date;
  public brandName: string;

  public firebaseToken: string;
  public firebaseTokenDate: Date|null;
  public languageCode: string;

  public isBlacklisted: boolean;
}

export class OrderCreationRequest extends Order {
  public refersionCartId: string;
  public partRef: string;
}

export class OrderList extends SoftDeleteEntity {

  public invoiceNumber: string;
  public cancellationInvoiceNumber: string;

  public orderLanguage: number;

  public invoiceId: number|null;

  public firstName: string;
  public lastName: string;

  public countryIsoCode: number;


  public dob: Date;
  public productId: number;

  public email: string;

  public orderDate: Date; // from file
  public shippedDate: Date|null;
  public awaitingShipmentDate: Date|null;



  public cardId: number|null;
  public customerId: number;


  public status: OrderStatus;
  public cancellationStatus: OrderCancellationStatus;


  public cancellationDate: Date; // from file

  public statusName: string;
  public productName: string;
  public productShortName: string;
  public countryName: string;

  public partnerCustomerId: string;





  public isReorderOrder: boolean;

  public webIdTransactionStatus: number;

  public source: string|null;

  public creationDate: Date;

  public customerPepStatus: PepStatus|null;
  public customerIdentStatus: IdentStatus|null;
  public productIsNoIdentCreationActive: boolean|null;
  public appDeviceOs: number|null;

  public cardName: string|null;
  public isImported: boolean;
  public hasWebIdTransaction: boolean;

}


export interface OrderView extends SoftDeleteEntity {
  externalRef: string | null;
  cardName: string | null;
  orderLanguage: number;
  invoiceId: number | null;
  cancellationInvoiceId: number | null;
  externalKey: string | null;
  protectedOrderId: string | null;
  invoiceNumber: string | null;
  cancellationInvoiceNumber: string | null;
  sex: string | null;
  title: string | null;
  firstName: string;
  lastName: string;
  customerCompanyName: string | null;
  address: string;
  zipCode: string;
  city: string;
  countryIsoCode: number;
  country: Country | null;
  phone: string;
  dob: Date;
  productId: number;
  email: string;
  nationality: string | null;
  ipAddress: string | null;
  orderDate: Date|null;
  awaitingShipmentDate: Date | null;
  shippedDate: Date | null;
  price: number;
  cancellationReason: OrderCancellationReason | null;
  cancellationStatus: OrderCancellationStatus | null;
  userCancellationReason: number | null;
  userCancellationReasonName: string | null;
  cancellationComment: string | null;
  cancellationDate: string | null;
  status: OrderStatus;
  importId: number | null;
  customerId: number | null;
  partnerCustomerId: string | null;
  cancellationReasonName: string | null;
  statusName: string;
  productName: string | null;
  productShortName: string | null;
  countryName: string | null;
  companyName: string | null;
  voucherCode: string | null;
  subscribeToNews: boolean;
  wantTotalCardInfos: boolean;
  isImported: boolean;
  language: string;
  paymentType: string | null;
  creationDate: Date;
  isReorderOrder: boolean;
  reorderedCardId: number | null;
  reorderReason: CardReorderReason | null;
  source: string | null;
  appDeviceId: number | null;
  appDevice: AppDevice | null;
}


export class OrderViewContainer {
  order: OrderView;
  product: Product;
  card: CardView | null;
  reorderedCard: CardView | null;
  invoice: Invoice;
  paymentEmailReminders: EmailReminder[];
  webIdTransaction: WebIdTransactionView | null;
}

export class WebIdTransactionView extends SoftDeleteEntity {
  status: IdentStatus;
  pepStatus: PepStatus | null;
  finishedOn: string | null;
  identifiedOn: string | null;
  responseFileId: number | null;
  url: string;
  providerCode: number;
  creationDate: Date;
  bioDataFirstName: string | null;
  bioDataLastName: string | null;
  bioDataDob: string | null;
  documentType: string | null;
  documentNumber: string | null;
  documentCountry: string | null;
  documentValidFrom: string | null;
  documentValidUntil: string | null;
}

export class Referral extends BaseEntity {
  status: ReferralStatus;
  customerId: number | null;
  customer: Customer | null;

  refereeCustomerId: number | null;
  referreeCustomer: Customer | null;

  phoneNumber: number;
  firstname: string|null;
  lastname: string|null;

  numberOfLoads: number;
  numberOfTransactions: number;
  targetNumberOfLoads: number;
  targetNumberOfTransactions: number;

  minTransactionAmount: number;

  possibleCommission: number;
  dueCommission: number;
  paidCommission: number;

  possibleRefereeCommission: number;
  dueRefereeCommission: number;
  paidRefereeCommission: number;

  bonusActionCode: string|null;
  bonusTxnId: string|null;

  expireDate: Date;

  identified: boolean;
  ordered: boolean;
  referralCreated: Date;
  referralAccepted: Date|null;
  paidCommissionDate: Date|null;


}

export class GiftCard extends BaseEntity {
  customerId: number | null;
  customer: Customer | null;

  creationDate: Date;
  expirationDate: Date|null;

  faceValue: number;
  faceCurrency: string;

  costAmount: number;
  costCurrency: string;

  purchasePrice: number;
  currency: string;
  brand: GiftCardBrand
  paymentTxnId: string|null;
  paymentTxnActionCode: string|null;
  isPaid: boolean;

}

export interface GiftCardBrand extends BaseEntity {

  category: GiftCardBrandCategory|null;
  categoryId: number|null

  isEnabled: boolean;
  slug: string;
  name: string;
  currency: string;
  lowerLimit: number|null;
  upperLimit: number|null;
  minorUnit: number;
  denominationsAvailable: string;
  discount: number;
  description: string;
  digitalActivationLimitText: string;
  digitalCancellationWindowText: string;
  expiryInfo: string;
  logoUrl: string;
  giftCardUrl: string;
  faqUrl: string;
  websiteUrl: string;
  userIsEnabled: boolean;
  userDiscount: number;
  userCashback: boolean;
  creationDate: Date;
  updateDate: Date|null;
  countriesServed: string;
  transactionTypes: string;
  barcode: string;
  sortOrder: number;
  termsAndConditionsCopy: string|null;
  termsAndConditionsUrl: string|null;
}

export class GiftCardBrandCategory extends BaseEntity {
  nameEn: string;
  nameDe: string;
  sortOrder: number;
  iconUrl: string;
}
